module.exports = __webpack_public_path__ + "static/pradedantysis-5a061678547c5cb4a3168dd031c9da99.svg";